// extracted by mini-css-extract-plugin
module.exports = {"label":"DataTypeSelect_label__ztbCp","input":"DataTypeSelect_input__2c4xZ","select":"DataTypeSelect_select__1IGof"};